import PaymentSelectForm from "@/components/Form/PaymentSelectForm/index";
import { jsx as _jsx } from "react/jsx-runtime";
export default function PurchaseFormStep1(_ref) {
  let {
    onSubmit,
    error,
    clearError,
    recaptchaSuccessV3,
    recaptchaCounterV2
  } = _ref;
  return /*#__PURE__*/_jsx(PaymentSelectForm, {
    mode: "tvod",
    onSubmit: onSubmit,
    error: error,
    clearError: clearError,
    paymentText: "\u5185\u5BB9\u306E\u78BA\u8A8D\u3078",
    recaptchaSuccessV3: recaptchaSuccessV3,
    recaptchaCounterV2: recaptchaCounterV2
  });
}